import Vue from 'vue';
import VueRouter from 'vue-router';

// Paths

export const paths = Object.freeze({
  admin: '/admin',
  home: '/',
  faq: '/faq',
  tickets: '/tickets',
  ticketEntry: '/ticket-entry',
  ticketExcursion: '/ticket-excursion',
  ticketsCount: '/tickets-count',
  pay: '/pay',
  selfie: '/selfie',
  entertainment: '/entertainment',
  feedback: '/feedback',
  audioInstruction: '/audio-instruction',
  audioRecording: '/audio-recording',
  audioSend: '/audio-send',
  videoInstruction: '/video-instruction',
  videoRecording: '/video-recording',
  videoSend: '/video-send',
  photoTake: '/photo-take',
  photoSend: '/photo-send',
  rate: '/rate',
});

// Routes

export const routes = [
  {
    path: paths.admin,
    name: 'Admin',
    component: () => import(/* webpackChunkName: "screens" */ '@/screens/Admin.vue'),
    meta: {
      back: -1,
      footer: true,
    },
  },
  {
    path: paths.home,
    name: 'Home',
    component: () => import(/* webpackChunkName: "screens" */ '@/screens/Home.vue'),
    meta: {
      back: false,
      footer: true,
    },
    props: true,
  },
  {
    path: paths.faq,
    name: 'Faq',
    component: () => import(/* webpackChunkName: "screens" */ '@/screens/Faq.vue'),
    meta: {
      back: paths.home,
      footer: true,
    },
  },
  {
    path: paths.tickets,
    name: 'Tickets',
    component: () => import(/* webpackChunkName: "screens" */ '@/screens/Tickets.vue'),
    meta: {
      back: paths.home,
      footer: true,
    },
  },
  {
    path: paths.ticketEntry,
    name: 'TicketEntry',
    component: () => import(/* webpackChunkName: "screens" */ '@/screens/TicketEntry.vue'),
    meta: {
      back: paths.tickets,
      footer: true,
    },
  },
  {
    path: paths.ticketExcursion,
    name: 'TicketExcursion',
    component: () => import(/* webpackChunkName: "screens" */ '@/screens/TicketExcursion.vue'),
    meta: {
      back: paths.tickets,
      footer: true,
    },
  },
  {
    path: paths.ticketsCount,
    name: 'TicketsCount',
    component: () => import(/* webpackChunkName: "screens" */ '@/screens/TicketsCount.vue'),
    meta: {
      back: paths.tickets,
      footer: true,
    },
  },
  {
    path: paths.pay,
    name: 'Pay',
    component: () => import(/* webpackChunkName: "screens" */ '@/screens/Pay.vue'),
    meta: {
      back: -1,
      footer: true,
    },
  },
  {
    path: paths.selfie,
    name: 'Selfie',
    component: () => import(/* webpackChunkName: "screens" */ '@/screens/Selfie.vue'),
    meta: {
      back: paths.home,
      footer: true,
    },
  },
  {
    path: paths.entertainment,
    name: 'Entertainment',
    component: () => import(/* webpackChunkName: "screens" */ '@/screens/Entertainment.vue'),
    meta: {
      back: paths.home,
      footer: true,
    },
  },
  {
    path: paths.feedback,
    name: 'Feedback',
    component: () => import(/* webpackChunkName: "screens" */ '@/screens/Feedback.vue'),
    meta: {
      back: paths.home,
      footer: true,
    },
  },
  {
    path: paths.audioInstruction,
    name: 'AudioInstruction',
    component: () => import(/* webpackChunkName: "screens" */ '@/screens/AudioInstruction.vue'),
    meta: {
      back: paths.feedback,
      footer: true,
    },
  },
  {
    path: paths.audioRecording,
    name: 'AudioRecording',
    component: () => import(/* webpackChunkName: "screens" */ '@/screens/AudioRecording.vue'),
    meta: {
      back: paths.audioInstruction,
      footer: true,
    },
  },
  {
    path: paths.audioSend,
    name: 'AudioSend',
    component: () => import(/* webpackChunkName: "screens" */ '@/screens/AudioSend.vue'),
    meta: {
      back: paths.audioInstruction,
      footer: true,
    },
  },
  {
    path: paths.videoInstruction,
    name: 'VideoInstruction',
    component: () => import(/* webpackChunkName: "screens" */ '@/screens/VideoInstruction.vue'),
    meta: {
      back: paths.feedback,
      footer: true,
    },
  },
  {
    path: paths.videoRecording,
    name: 'VideoRecording',
    component: () => import(/* webpackChunkName: "screens" */ '@/screens/VideoRecording.vue'),
    meta: {
      back: paths.videoInstruction,
      footer: false,
    },
  },
  {
    path: paths.videoSend,
    name: 'VideoSend',
    component: () => import(/* webpackChunkName: "screens" */ '@/screens/VideoSend.vue'),
    meta: {
      back: paths.videoInstruction,
      footer: true,
    },
  },
  {
    path: paths.photoTake,
    name: 'PhotoTake',
    component: () => import(/* webpackChunkName: "screens" */ '@/screens/PhotoTake.vue'),
    meta: {
      back: paths.entertainment,
      footer: false,
    },
  },
  {
    path: paths.photoSend,
    name: 'PhotoSend',
    component: () => import(/* webpackChunkName: "screens" */ '@/screens/PhotoSend.vue'),
    meta: {
      back: paths.photoTake,
      footer: true,
    },
  },
  {
    path: paths.rate,
    name: 'Rate',
    component: () => import(/* webpackChunkName: "screens" */ '@/screens/Rate.vue'),
    meta: {
      back: paths.home,
      footer: true,
    },
  },
];

// Router

Vue.use(VueRouter);

const router = new VueRouter({
  linkActiveClass: '_active',
  linkExactActiveClass: '_active_exact',
  paths,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

export default router;
